import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";

const useStyles = makeStyles((theme) => ({
  footer: {
    // textAlign: theme.direction === "rtl" ? "right" : "left",
    textAlign: "center",
    padding: theme.spacing(3, 2),

    marginTop: "auto",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
  },
}));

export default function StickyFooter() {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <Container maxWidth="sm">
        <Typography variant="body1">
          ساخته شده با
          <span role="img" aria-label="heart" color="red">
            ❤️
          </span>
          توسط
          <Link href="https://twitter.com/ghodsizadeh"> مهدی قدسی‌زاده </Link>
        </Typography>
      </Container>
    </footer>
  );
}
